import React from 'react';
import { FiPlus } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

import {
  PageHeader,
  type PageHeaderAction,
} from '../../../../components/PageHeader';

export const UsersHeader: React.FC = () => {
  const navigate = useNavigate();

  const pageActions: PageHeaderAction[] = [
    {
      label: 'Create User',
      icon: <FiPlus className="h-4 w-4" />,
      onClick: () => navigate('/users/create'),
      color: 'primary',
    },
  ];

  return (
    <PageHeader
      title="Users Management"
      description="Manage buyers and suppliers across the platform"
      actions={pageActions}
    />
  );
};
